import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'

import StatusBannerPage from 'components_new/pages/internal/StatusBanner'
import DataHealthPage from 'components_new/pages/internal/DataHealth'
import DataHealthIncidentProcessPage from 'components_new/pages/internal/DataHealthIncidentProcess'
import SimChatsPage from 'components_new/pages/internal/SimChats'
import MetricStudioPage from 'components_new/pages/internal/MetricStudio'
import MetricStudioEditorPage from 'components_new/pages/internal/MetricStudio/Editor'
import TrustLinksPage from 'components_new/pages/internal/TrustLinks'
import UserPage from 'components_new/pages/internal/User'
import UsersPage from 'components_new/pages/internal/Users'
import CustomerPage from 'components_new/pages/internal/Customer'
import CustomersPage from 'components_new/pages/internal/Customers'

import {
  useAccountSettings,
  useIsAuthenticated
} from 'redux/hooks/SignedInAccount'

import AuthRoute from './AuthRoute'

const Routes = () => {
  const isAuthenticated = useIsAuthenticated()
  const { isHomepal, isInProductTeam } = useAccountSettings()

  return (
    <Switch>
      <AuthRoute
        isAuthenticated={isAuthenticated && isHomepal}
        Component={() => <StatusBannerPage />}
        path={'/internal/status-banner'}
        exact
      />
      <AuthRoute
        isAuthenticated={isAuthenticated && isHomepal}
        Component={() => <DataHealthIncidentProcessPage />}
        path={'/internal/data-health/incident-process'}
        exact
      />
      <AuthRoute
        isAuthenticated={isAuthenticated && isHomepal}
        Component={() => <DataHealthPage />}
        path={'/internal/data-health/:tab'}
      />
      <Route path={'/internal/data-health'} exact>
        <Redirect to="/internal/data-health/overview" />
      </Route>

      <AuthRoute
        isAuthenticated={isAuthenticated && isHomepal}
        Component={() => <SimChatsPage />}
        path={'/internal/sim-chats'}
        exact
      />

      <AuthRoute
        isAuthenticated={isAuthenticated && isHomepal}
        Component={() => <MetricStudioPage />}
        path={'/internal/metric-studio'}
        exact
      />
      <AuthRoute
        isAuthenticated={isAuthenticated && isInProductTeam}
        Component={() => <MetricStudioEditorPage />}
        path={'/internal/metric-studio/new'}
        exact
      />
      <AuthRoute
        isAuthenticated={isAuthenticated && isInProductTeam}
        Component={() => <MetricStudioEditorPage />}
        path={'/internal/metric-studio/:id'}
        exact
      />
      <AuthRoute
        isAuthenticated={isAuthenticated && isInProductTeam}
        Component={() => <TrustLinksPage />}
        path={'/internal/trust-links'}
        exact
      />

      <AuthRoute
        isAuthenticated={isAuthenticated && isHomepal}
        Component={() => <UsersPage />}
        path={'/internal/users'}
        exact
      />
      <AuthRoute
        isAuthenticated={isAuthenticated && isHomepal}
        Component={() => <UserPage />}
        path={'/internal/users/:id'}
        exact
      />
      <AuthRoute
        isAuthenticated={isAuthenticated && isHomepal}
        Component={() => <CustomersPage />}
        path={'/internal/customers'}
        exact
      />
      <AuthRoute
        isAuthenticated={isAuthenticated && isHomepal}
        Component={() => <CustomerPage />}
        path={'/internal/customers/:id'}
        exact
      />
    </Switch>
  )
}

export default Routes
